import { getGlobalConfig } from '../../config/config'
import { CLEAR_ALL_BRANCH } from './BranchActions'
import { CLEAR_ALL_DELIVERYZONE, CLEAR_ZONES_LOADING } from './DeliveryZoneActions'
import { CLEAR_ALL_LOYALTY, CLEAR_LOYALTY_LOADING } from './LoyaltyActions'
import { CLEAR_MODULES_LOADING } from './ModulesActions'
import { CLEAR_USERS_LOADING } from './UsersActions'
import { CLEAR_ALL_QR, CLEAR_QR_LOADING } from './QRActions'
import { CLEAR_NOTIFICATIONS, CLEAR_NOTIFICATIONS_LOADING } from './NotificationsActions'
import { CLEAR_MESSAGES_LOADING } from './MessagesActions'
import { CLEAR_TRANSLATIONS_LOADING } from './TranslationsActions'

import { handleError } from '../../utils/utils'

/**
 * These belong to lazily-injected feature reducer groups. Sourced from a plain
 * constants file (not each domain's XActions.js) so GlobalActions.js - which is
 * part of the eager core reducer set - doesn't drag those domains' full modules
 * (and their config.js API slices) into the main bundle. See globalClearActionTypes.js.
 */
import {
  CLEAR_ALL_BRANCHES_FINANCE, CLEAR_BRANCHES_FINANCE_LOADING,
  CLEAR_ALL_CATEGORY, CLEAR_CATEGORY_LOADING,
  CLEAR_ALL_DISCOUNT, CLEAR_DISCOUNT_LOADING,
  CLEAR_ALL_EVENTS, CLEAR_EVENTS_LOADING,
  CLEAR_ALL_FEEDBACKS, CLEAR_FEEDBACK_LOADING,
  CLEAR_ALL_GALLERY, CLEAR_GALLERY_LOADING,
  CLEAR_ALL_GROUP, CLEAR_GROUP_LOADING,
  CLEAR_INGREDIENT_LOADING,
  CLEAR_ALL_MEDIA, CLEAR_MEDIA_LOADING,
  CLEAR_MENU, CLEAR_MENU_LOADING,
  CLEAR_ALL_MODIFIER, CLEAR_MODIFIERS_LOADING,
  CLEAR_ALL_MODIFIERGROUP, CLEAR_MODIFIERS_GROUPS_LOADING,
  CLEAR_ORDER_LOADING,
  CLEAR_ALL_PLATFORMS, CLEAR_PLATFORM_LOADING,
  CLEAR_ALL_PRODUCT, CLEAR_PRODUCTS_LOADING,
  CLEAR_PROFILE_LOADING,
  CLEAR_ALL_PROMOTIONS, CLEAR_PROMO_LOADING,
  CLEAR_ROLE_LOADING,
  CLEAR_ALL_TAX, CLEAR_TAX_LOADING,
  CLEAR_ALL_TYPES_AND_ALLERGIES, CLEAR_TYPES_LOADING,
  CLEAR_ALLERGENS_LOADING,
  RESET_APP_USER_ADDRESSES, CLEAR_APP_USER_ADDRESSES_LOADING,
  CLEAR_APP_USERS_LOADING,
  CLEAR_DESIGN_LOADING,
  CLEAR_URL_LINK_LOADING,
  CLEAR_AUTO_MSG_LOADING,
  CLEAR_FLOOR_LOADING,
  CLEAR_LOGIN_DESIGN_LOADING,
  CLEAR_POS_LOGIN_DESIGN_LOADING,
  CLEAR_PRODUCTS_AVAILABILITY_LOADING,
  CLEAR_SPLASH_SCREEN_LOADING,
  CLEAR_PAYMENTS,
  CLEAR_ALL_DM, CLEAR_LOADING_DM,
} from './globalClearActionTypes'

export const GET_GLOBALCONFIG_REQUEST = 'GET_GLOBALCONFIG_REQUEST'
export const GET_GLOBALCONFIG_SUCCESS = 'GET_GLOBALCONFIG_SUCCESS'
export const GET_GLOBALCONFIG_ERROR = 'GET_GLOBALCONFIG_ERROR'
export const CLEAR_GLOBALCONFIG = 'CLEAR_GLOBALCONFIG'


const actions = {
  clearLoading: () => async (dispatch) => {
    dispatch({
      type: CLEAR_LOADING_DM
    })
    dispatch({
      type: CLEAR_URL_LINK_LOADING
    })
    dispatch({
      type: CLEAR_ALLERGENS_LOADING
    })
    dispatch({
      type: CLEAR_APP_USER_ADDRESSES_LOADING
    })
    dispatch({
      type: CLEAR_APP_USERS_LOADING
    })
    dispatch({
      type: CLEAR_AUTO_MSG_LOADING
    })
    dispatch({
      type: CLEAR_BRANCHES_FINANCE_LOADING
    })
    dispatch({
      type: CLEAR_CATEGORY_LOADING
    })
    dispatch({
      type: CLEAR_ZONES_LOADING
    })
    dispatch({
      type: CLEAR_DESIGN_LOADING
    })
    dispatch({
      type: CLEAR_DISCOUNT_LOADING
    })
    dispatch({
      type: CLEAR_EVENTS_LOADING
    })
    dispatch({
      type: CLEAR_FEEDBACK_LOADING
    })
    dispatch({
      type: CLEAR_FLOOR_LOADING
    })
    dispatch({
      type: CLEAR_GALLERY_LOADING
    })
    dispatch({
      type: CLEAR_GROUP_LOADING
    })
    dispatch({
      type: CLEAR_INGREDIENT_LOADING
    })
    dispatch({
      type: CLEAR_LOGIN_DESIGN_LOADING
    })
    dispatch({
      type: CLEAR_POS_LOGIN_DESIGN_LOADING
    })
    dispatch({
      type: CLEAR_LOYALTY_LOADING
    })
    dispatch({
      type: CLEAR_MEDIA_LOADING
    })
    dispatch({
      type: CLEAR_MENU_LOADING
    })
    dispatch({
      type: CLEAR_MESSAGES_LOADING
    })
    dispatch({
      type: CLEAR_MODIFIERS_LOADING
    })
    dispatch({
      type: CLEAR_MODIFIERS_GROUPS_LOADING
    })
    dispatch({
      type: CLEAR_MODULES_LOADING
    })
    dispatch({
      type: CLEAR_NOTIFICATIONS_LOADING
    })
    dispatch({
      type: CLEAR_ORDER_LOADING
    })
    dispatch({
      type: CLEAR_PLATFORM_LOADING
    })
    dispatch({
      type: CLEAR_PRODUCTS_LOADING
    })
    dispatch({
      type: CLEAR_PRODUCTS_AVAILABILITY_LOADING
    })
    dispatch({
      type: CLEAR_PROFILE_LOADING
    })
    dispatch({
      type: CLEAR_PROMO_LOADING
    })
    dispatch({
      type: CLEAR_QR_LOADING
    })
    dispatch({
      type: CLEAR_ROLE_LOADING
    })
    dispatch({
      type: CLEAR_SPLASH_SCREEN_LOADING
    })
    dispatch({
      type: CLEAR_TAX_LOADING
    })
    dispatch({
      type: CLEAR_TRANSLATIONS_LOADING
    })
    dispatch({
      type: CLEAR_TYPES_LOADING
    })
    dispatch({
      type: CLEAR_USERS_LOADING
    })
  },
  // Get All global variables
  getGlobalConfig: () => async (dispatch) => {
    dispatch({
      type: GET_GLOBALCONFIG_REQUEST,
    })
    await getGlobalConfig().then((res) => {
      if (res?.status === 200) {
        let countries = []
        let currencies = []
        if (res.data.countries) {
          countries = [...res.data.countries]
          countries.sort((a, b) => a.countryName.localeCompare(b.countryName))
          res.data.countries = countries
        }
        if (res.data.currencies) {
          currencies = [...res.data.currencies]
          currencies.sort((a, b) => a.currencyName.localeCompare(b.currencyName))
          res.data.currencies = currencies
        }
        dispatch({
          type: GET_GLOBALCONFIG_SUCCESS,
          payload: res.data,
        })
      } else {
        handleError(dispatch)(res, GET_GLOBALCONFIG_ERROR, 'GET GLOBALS ERROR')
      }
    })
  },
  clearGlobalConfig: () => (dispatch) => {
    dispatch({
      type: CLEAR_GLOBALCONFIG
    })
  },


  clearAllData: () => (dispatch) => {
    dispatch({
      type: CLEAR_ALL_DM
    })
    dispatch({
      type: CLEAR_ALL_QR
    })
    dispatch({
      type: RESET_APP_USER_ADDRESSES
    })
    dispatch({
      type: CLEAR_ALL_BRANCH
    })
    dispatch({
      type: CLEAR_ALL_BRANCHES_FINANCE
    })
    dispatch({
      type: CLEAR_ALL_DELIVERYZONE
    })
    dispatch({
      type: CLEAR_ALL_CATEGORY
    })
    dispatch({
      type: CLEAR_ALL_DISCOUNT
    })
    dispatch({
      type: CLEAR_ALL_EVENTS
    })
    dispatch({
      type: CLEAR_ALL_FEEDBACKS
    })
    dispatch({
      type: CLEAR_ALL_GALLERY
    })
    dispatch({
      type: CLEAR_ALL_GROUP
    })
    dispatch({
      type: CLEAR_ALL_LOYALTY
    })
    dispatch({
      type: CLEAR_ALL_MEDIA
    })
    dispatch({
      type: CLEAR_MENU
    })
    dispatch({
      type: CLEAR_ALL_MODIFIER
    })
    dispatch({
      type: CLEAR_ALL_MODIFIERGROUP
    })
    dispatch({
      type: CLEAR_ALL_PLATFORMS
    })
    dispatch({
      type: CLEAR_ALL_PRODUCT
    })
    dispatch({
      type: CLEAR_ALL_PROMOTIONS
    })
    dispatch({
      type: CLEAR_ALL_TAX
    })
    dispatch({
      type: CLEAR_ALL_TYPES_AND_ALLERGIES
    })
    dispatch({
      type: CLEAR_NOTIFICATIONS
    })
    dispatch({
      type: CLEAR_PAYMENTS
    })
  }
}

export default actions
